import { render, staticRenderFns } from "./ScreenPelvicaTransabdominal.vue?vue&type=template&id=10b4acea&scoped=true&"
import script from "./ScreenPelvicaTransabdominal.vue?vue&type=script&lang=js&"
export * from "./ScreenPelvicaTransabdominal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPelvicaTransabdominal.vue?vue&type=style&index=0&id=10b4acea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4acea",
  null
  
)

export default component.exports